import React, {Fragment, useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {toggleModal} from "../../store/actions/toggleModalActions";
import searchIcon from "../../assets/icons/plus.svg";
import ExternalModal from "../_common/ExternalModal";
import Sensor from "../Sensor";
import ManageUsers from "../ManageUsers";
import {isCompanyAdmin, isCustomer, isDistributorAdmin, isSuperAdmin} from "../../helpers/helpers";
import ButtonSpinner from "../_common/ButtonSpinner";
import {addDrainStation, deleteDrainStation, editDrainStation} from "../../store/actions/drainStationsActions";
import MapView from "../Maps/MapView";
import DrainWaterStationHistory from "./DrainWaterStationHistory";

const selector = state => {
    const { language, disableButtons, companies, modalState } = state;
    return {
        t: language.translator,
        disableButtons: disableButtons,
        companies: companies.companies,
        modalState: modalState
    }
};

const defaultForm = {
    name: '',
    inWaterCountSensorId: '',
    outWaterCountSensorId: '',
    userId: '',
    multiplier: '',
    divider: '',
    calibrateIn: '',
    calibrateOut: '',
    inPhSensorId: '',
    outPhSensorId: '',
    inEcSensorId: '',
    outEcSensorId: '',
    lat: '',
    lon: '',
}

const DrainStationModal = props => {
    const {edit, details, station} = props;
    const { t, disableButtons } = useSelector(selector);
    const dispatch = useDispatch();

    const [deleteConfirmation, setDeleteConfirmation] = useState(false);
    const [formValues, setFormValues] = useState({...defaultForm})
    const [nameValues, setNameValues] = useState({})
    const [sensorsModal, setSensorsModal] = useState({isOpen: false, type: '', enumType: '', name: ''})
    const [usersModal, setUsersModal] = useState({isOpen: false, name: ''})
    const [error, setError] = useState(false)
    const [showStationData, setShowStationData] = useState(false)

    const [mapHasBeenClicked, setMapHasBeenClicked] = useState(false);
    const getCoordinatesFromMap = (latlng) => {
        setMapHasBeenClicked(true);
        setFormValues({ ...formValues, lat: latlng.lat, lon: latlng.lng})
    };


    useEffect(() => {
       if(station) {
           setFormValues({
               id: station && station.id ? station.id.toString() : '',
               name: station && station.name ? station.name.toString() : '',
               // rainSensorId: station && station.rainSensorId ? station.rainSensorId.toString() : '',
               // inWaterCountSensorId: station && station.windSpeedSensorId ? station.windSpeedSensorId.toString() : '',
               // outWaterCountSensorId: station && station.wetLeafSensorId ? station.wetLeafSensorId.toString() : '',
               inWaterCountSensorId: station && station.inWaterCountSensorId ? station.inWaterCountSensorId.toString() : '',
               outWaterCountSensorId: station && station.outWaterCountSensorId ? station.outWaterCountSensorId.toString() : '',
               userId: station && station.userId ? station.userId.toString() : '',
               multiplier: station && station.multiplier ? station.multiplier.toString() : '',
               divider: station && station.divider ? station.divider.toString() : '',
               calibrateIn: station && station.calibrateIn ? station.calibrateIn.toString() : '',
               calibrateOut: station && station.calibrateOut ? station.calibrateOut.toString() : '',
               inPhSensorId: station && station.inPhSensorId ? station.inPhSensorId.toString() : '',
               outPhSensorId: station && station.outPhSensorId ? station.outPhSensorId.toString() : '',
               inEcSensorId: station && station.inEcSensorId ? station.inEcSensorId.toString() : '',
               outEcSensorId: station && station.outEcSensorId ? station.outEcSensorId.toString() : '',
               lat: station && station.lat ? station.lat : '',
               lon: station && station.lon ? station.lon : '',
           })
           setNameValues({
               inSensorName: station && station.inWaterCountSensor && station.inWaterCountSensor.name ? station.inWaterCountSensor.name : '',
               outSensorName: station && station.outWaterCountSensor && station.outWaterCountSensor.name ? station.outWaterCountSensor.name : '',
               userName: station && station.userName  ? station.userName : '',
               inPhSensorName: station && station.inPhSensor && station.inPhSensor.name  ? station.inPhSensor.name : '',
               outPhSensorName: station && station.outPhSensor && station.outPhSensor.name  ? station.outPhSensor.name : '',
               inEcSensorName: station && station.inEcSensor && station.inEcSensor.name  ? station.inEcSensor.name : '',
               outEcSensorName: station && station.outEcSensor && station.outEcSensor.name  ? station.outEcSensor.name : '',
               // inPhSensorId: station && station.inPhSensor
           })
       }
    },[])

    const handleDeleteStationClick = () => {
        setDeleteConfirmation(!deleteConfirmation)
    };

    const closeModal = () => {
        dispatch(toggleModal(false, ''));
    };

    const toggleSensorsModal = (type, enumType, name) => {
        setSensorsModal({isOpen: !sensorsModal.isOpen, type: type, enumType: enumType, name: name})
    }

    const toggleUsersModal = (name) => {
        setUsersModal({isOpen: !usersModal.isOpen, name: name})
    }

    const selectSensorId = (sensorType, sensor, sensorName, name) => {
        setFormValues({...formValues, [sensorType]: sensor.toString()})
        setNameValues({...nameValues, [sensorName]: name})
    }

    const selectUserId = (id, name) => {
        setFormValues({...formValues, userId: id.toString() })
        setNameValues({...nameValues, userName: name})
    }

    const handleAddStationClick = () => {
        if(!isCustomer()) {
            if(formValues.name.length && formValues.userId.length && formValues.inWaterCountSensorId.length && formValues.outWaterCountSensorId.length) {
                if(!edit) {
                    dispatch(addDrainStation(formValues))
                } else {
                    dispatch(editDrainStation(formValues))
                }
                closeModal()
            } else {
                setError(true)
                setTimeout(() => setError(false), 5000)
            }
        } else {
            if(formValues.name.length  && formValues.inWaterCountSensorId.length && formValues.outWaterCountSensorId.length) {
                if(!edit) {
                    dispatch(addDrainStation(formValues))
                } else {
                    dispatch(editDrainStation(formValues))
                }
                closeModal()
            } else {
                setError(true)
                setTimeout(() => setError(false), 5000)
            }
        }
    }

    const confirmDeleteDrainStation = id => {
        dispatch(deleteDrainStation(id))
        closeModal()
    }

    const stationMarker = station && station.lat != null && station.lon != null
        ? [{
            lat: station.lat,
            lng: station.lon,
            color: "#FFAC0C",
            name: station.name,
            id: station.id
        }]
        : [];

    if (showStationData && station) {
        return (
            <DrainWaterStationHistory
                station={station}
                onBack={() => setShowStationData(false)}
                onClose={closeModal}
            />
        );
    }

    return (
        <div
            className={details ? 'userModalDetails' : 'userModalBlur'}
            onClick={e => {
                if(e.target.className === 'userModalBlur') {
                    closeModal()
                }
            }}
        >
            <div style={{height: '90%'}} className={details ? 'userModal inDetails' : 'userModal'}>
                <div className="userModalHeader">
                    <div className="userModalTitleContainer">
                        <div className='userModalTitle'>
                            {!edit ? t.gettext('Add New Drain Station') : t.gettext('Edit Drain Station')}
                        </div>
                    </div>
                    <div className='userModalCloseButtonHolder'>
                        <span
                            className='material-icons userModalCloseButton'
                            onClick={closeModal}
                        >
                            cancel
                        </span>
                    </div>
                </div>
                <div style={!error ? {"visibility": "hidden"} : null}
                     className='weatherStationError'>{t.gettext('Some required fields are missing')}.
                </div>
                <div className='userModalContent weatherStationContent'>
                    <form className="userForm" autoComplete='off'>
                        {(isSuperAdmin() || isCompanyAdmin() || isDistributorAdmin()) && (
                            <Fragment>
                                <div className='stationMap'>
                                    <MapView
                                        zoom={12}
                                        center={{
                                            lat: station && station.lat ? station.lat : 52.2297,
                                            lng: station && station.lon ? station.lon : 21.0122
                                        }}
                                        markers={edit ? stationMarker : null}
                                        getCoordinates={getCoordinatesFromMap}
                                        mapHasBeenClicked={mapHasBeenClicked}
                                        avoidResize
                                    />
                                </div>
                                <div className="stationModalFormRow">
                                    <div className='userFormItem stationFormItem'>
                                        <label className='userFormLabel'>
                                            {t.gettext('Latitude')}
                                        </label>
                                        <input
                                            className='userFormInput'
                                            onInput={e => {
                                                setFormValues({...formValues, lat: e.target.value});
                                            }}
                                            defaultValue={station ? station.lat : formValues.lat}
                                            value={formValues.lat}
                                            type='number'
                                        />
                                    </div>
                                    <div className='userFormItem stationFormItem'>
                                        <label className='userFormLabel'>
                                            {t.gettext('Longitude')}
                                        </label>
                                        <input
                                            className='userFormInput'
                                            onInput={e => {
                                                setFormValues({...formValues, lon: e.target.value});
                                            }}
                                            type='number'
                                            defaultValue={station ? station.lon : formValues.lon}
                                            value={formValues.lon}
                                        />
                                    </div>
                                </div>
                            </Fragment>
                        )}

                        <div className='userFormItem'>
                            <label className='userFormLabel'>
                                {t.gettext('Name')}
                            </label>
                            <input
                                style={error && !formValues.name ? {'borderBottom': '1px solid #D91212'} : null}
                                className='userFormInput'
                                defaultValue={station ? station.name : ''}
                                onInput={e => {
                                    setFormValues({...formValues, name: e.target.value});
                                }}
                                type='text'
                            />
                        </div>
                        {details && (
                            <div className='userFormItem'>
                                <label className='userFormLabel'>
                                    {t.gettext('User Name')}
                                </label>
                                <input

                                    className='userFormInput'
                                    defaultValue={station ? station.userName : ''}
                                    disabled
                                    type='text'
                                />
                            </div>
                        )}
                        {!isCustomer() &&
                            <div className='userFormItem sensorPickerInput'>
                                <label className='userFormLabel'>
                                    {t.gettext('User')}
                                </label>
                                <input
                                    readOnly
                                    style={error && !formValues.userId ? {'borderBottom': '1px solid #D91212'} : null}
                                    className='userFormInput'
                                    onInput={e => {
                                        setFormValues({...formValues, userId: e.target.value});
                                    }}
                                    type='text'
                                    value={nameValues.userName}
                                    // defaultValue={station ? station.userId : formValues.userId}
                                    // value={formValues.userId}
                                />
                                <img className={'inputIcon icon--right'} src={searchIcon} alt='icon'
                                     onClick={() => toggleUsersModal()}/>
                            </div>
                        }
                        <div className='userFormItem sensorPickerInput'>
                            <label className='userFormLabel'>
                                {t.gettext('In Sensor')}
                            </label>
                            <input
                                style={error && !formValues.inWaterCountSensorId ? {'borderBottom': '1px solid #D91212'} : null}
                                readOnly
                                className='userFormInput '
                                onInput={e => {
                                    setFormValues({...formValues, inWaterCountSensorId: e.target.value});
                                }}
                                type='text'
                                // defaultValue={station ? station.rainSensorId : formValues.rainSensorId}
                                value={nameValues.inSensorName}
                            />
                            <img className={'inputIcon icon--right'} src={searchIcon} alt='icon'
                                 onClick={() => toggleSensorsModal('inWaterCountSensorId', 'DRAIN_WATER_COUNT', 'inSensorName')}/>
                        </div>
                        <div className='userFormItem sensorPickerInput'>
                            <label className='userFormLabel'>
                                {t.gettext('Out Sensor')}
                            </label>
                            <input
                                style={error && !formValues.outWaterCountSensorId ? {'borderBottom': '1px solid #D91212'} : null}
                                readOnly
                                className='userFormInput '
                                onInput={e => {
                                    setFormValues({...formValues, outWaterCountSensorId: e.target.value});
                                }}
                                type='text'
                                // defaultValue={station ? station.rainSensorId : formValues.rainSensorId}
                                value={nameValues.outSensorName}
                            />
                            <img className={'inputIcon icon--right'} src={searchIcon} alt='icon'
                                 onClick={() => toggleSensorsModal('outWaterCountSensorId', 'DRAIN_WATER_COUNT', 'outSensorName')}/>
                        </div>


                        <div className='userFormItem sensorPickerInput'>
                            <label className='userFormLabel'>
                                {t.gettext('EC In Sensor')}
                            </label>
                            <input
                                readOnly
                                className='userFormInput '
                                onInput={e => {
                                    setFormValues({...formValues, inEcSensorId: e.target.value});
                                }}
                                type='text'
                                value={nameValues.inEcSensorName}
                            />
                            <img className={'inputIcon icon--right'} src={searchIcon} alt='icon'
                                 // onClick={() => toggleSensorsModal('inEcSensorId', 'PH_EC_DRAIN_WATER', 'inEcSensorName')}/>
                                 onClick={() => toggleSensorsModal('inEcSensorId', 'DRAIN_WATER_EC', 'inEcSensorName')}/>
                        </div>
                        <div className='userFormItem sensorPickerInput'>
                            <label className='userFormLabel'>
                                {t.gettext('EC Out Sensor')}
                            </label>
                            <input
                                readOnly
                                className='userFormInput '
                                onInput={e => {
                                    setFormValues({...formValues, outEcSensorId: e.target.value});
                                }}
                                type='text'
                                // defaultValue={station ? station.rainSensorId : formValues.rainSensorId}
                                value={nameValues.outEcSensorName}
                            />
                            <img className={'inputIcon icon--right'} src={searchIcon} alt='icon'
                                 // onClick={() => toggleSensorsModal('outEcSensorId', 'PH_EC_DRAIN_WATER', 'outEcSensorName')}/>
                                 onClick={() => toggleSensorsModal('outEcSensorId', 'DRAIN_WATER_EC', 'outEcSensorName')}/>
                        </div>
                        <div className='userFormItem sensorPickerInput'>
                            <label className='userFormLabel'>
                                {t.gettext('PH In Sensor')}
                            </label>
                            <input
                                readOnly
                                className='userFormInput '
                                onInput={e => {
                                    setFormValues({...formValues, inPhSensorId: e.target.value});
                                }}
                                type='text'
                                // defaultValue={station ? station.rainSensorId : formValues.rainSensorId}
                                value={nameValues.inPhSensorName}
                            />
                            <img className={'inputIcon icon--right'} src={searchIcon} alt='icon'
                                 // onClick={() => toggleSensorsModal('inPhSensorId', 'PH_EC_DRAIN_WATER', 'inPhSensorName')}/>
                                 onClick={() => toggleSensorsModal('inPhSensorId', 'DRAIN_WATER_PH', 'inPhSensorName')}/>
                        </div>
                        <div className='userFormItem sensorPickerInput'>
                            <label className='userFormLabel'>
                                {t.gettext('PH Out Sensor')}
                            </label>
                            <input
                                readOnly
                                className='userFormInput '
                                onInput={e => {
                                    setFormValues({...formValues, outPhSensorId: e.target.value});
                                }}
                                type='text'
                                // defaultValue={station ? station.rainSensorId : formValues.rainSensorId}
                                value={nameValues.outPhSensorName}
                            />
                            <img className={'inputIcon icon--right'} src={searchIcon} alt='icon'
                                 // onClick={() => toggleSensorsModal('outPhSensorId', 'PH_EC_DRAIN_WATER', 'outPhSensorName')}/>
                                 onClick={() => toggleSensorsModal('outPhSensorId', 'DRAIN_WATER_PH', 'outPhSensorName')}/>
                        </div>

                        <div className="stationModalFormRow">
                            <div className='userFormItem stationFormItem'>
                                <label className='userFormLabel'>
                                    {t.gettext('Multiplier')}
                                </label>
                                <input
                                    className='userFormInput'
                                    onInput={e => {
                                        setFormValues({...formValues, multiplier: e.target.value});
                                    }}
                                    defaultValue={station ? station.multiplier : formValues.multiplier}
                                    value={formValues.multiplier}
                                    type='number'
                                />
                            </div>
                            <div className='userFormItem stationFormItem'>
                                <label className='userFormLabel'>
                                    {t.gettext('Divider')}
                                </label>
                                <input
                                    className='userFormInput'
                                    onInput={e => {
                                        setFormValues({...formValues, divider: e.target.value});
                                    }}
                                    type='number'
                                    defaultValue={station ? station.divider : formValues.divider}
                                    value={formValues.divider}
                                />
                            </div>
                        </div>
                        <div className="stationModalFormRow">
                            <div className='userFormItem stationFormItem'>
                                <label className='userFormLabel'>
                                    {t.gettext('Calibrate In')}
                                </label>
                                <input
                                    className='userFormInput'
                                    onInput={e => {
                                        setFormValues({...formValues, calibrateIn: e.target.value});
                                    }}
                                    defaultValue={station ? station.calibrateIn : formValues.calibrateIn}
                                    value={formValues.calibrateIn}
                                    type='number'
                                />
                            </div>
                            <div className='userFormItem stationFormItem'>
                                <label className='userFormLabel'>
                                    {t.gettext('Calibrate Out')}
                                </label>
                                <input
                                    className='userFormInput'
                                    onInput={e => {
                                        setFormValues({...formValues, calibrateOut: e.target.value});
                                    }}
                                    type='number'
                                    defaultValue={station ? station.calibrateOut : formValues.calibrateOut}
                                    value={formValues.calibrateOut}
                                />
                            </div>
                        </div>
                        <div className='userButtonsHolder'>
                            {!edit &&
                                <button
                                    className='userAddButton'
                                    onClick={e => {
                                        e.preventDefault();
                                        handleAddStationClick();
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('Add Station')}
                                    {disableButtons && <ButtonSpinner black/>}
                                </button>
                            }

                            {edit &&

                                <>
                                    <button
                                        className='userAddButton'
                                        onClick={e => {
                                            e.preventDefault();
                                            setShowStationData(true);
                                        }}
                                        disabled={disableButtons}
                                    >
                                        {t.gettext('Station Data')}
                                    </button>
                                    <button
                                        className='userAddButton userDeleteButton'
                                        onClick={e => {
                                            e.preventDefault();
                                            handleDeleteStationClick();
                                        }}
                                        disabled={disableButtons}
                                    >
                                        {t.gettext('Delete Station')}
                                    </button>
                                    <button
                                        className='userAddButton userEditButton'
                                        onClick={e => {
                                            e.preventDefault();
                                            handleAddStationClick();
                                            // handleEditUserClick();
                                        }}
                                        disabled={disableButtons}
                                    >
                                        {t.gettext('Save')}
                                        {disableButtons && <ButtonSpinner black/>}
                                    </button>
                                </>

                            }
                        </div>

                        {deleteConfirmation &&
                            <div className='userDeleteConfirmation' style={{justifyContent: 'center'}}>
                                {station.name + ' ' + t.gettext('will be deleted')}
                                <button
                                    className='confirmationButton'
                                    onClick={e => {
                                        e.preventDefault();
                                        confirmDeleteDrainStation(station.id);
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('OK')}
                                </button>
                                <button
                                    className='confirmationButton confirmationButton--cancel'
                                    onClick={e => {
                                        e.preventDefault();
                                        handleDeleteStationClick();
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('Cancel')}
                                </button>
                            </div>
                        }
                        {sensorsModal.isOpen &&
                            <ExternalModal
                                closeMethod={() => toggleSensorsModal(sensorsModal.type)}
                                title={'Sensors'}
                            >
                                <Sensor
                                    sensorPicker
                                    sensorPickerEnum={sensorsModal.enumType}
                                    selectSensorPicker={selectSensorId}
                                    sensorPickerType={sensorsModal.type}
                                    sensorPickerName={sensorsModal.name}
                                    toggleSensorPicker={toggleSensorsModal}
                                    userId={formValues.userId}
                                />
                            </ExternalModal>
                        }
                        {usersModal.isOpen &&
                            <ExternalModal
                                closeMethod={() => toggleUsersModal()}
                                title={'Users'}
                            >
                                <ManageUsers
                                    superAdmin={isSuperAdmin()}
                                    userPicker
                                    selectUserPicker={selectUserId}
                                    toggleUserPicker={toggleUsersModal}
                                />
                            </ExternalModal>
                        }
                    </form>
                </div>
            </div>
        </div>
    )
}

export default DrainStationModal
